import gtm from "./gtm";

export default {
  gtm,
};
